import { getToolById } from '../apis/ToolRegistration'

export async function validateToolIdInToolListListener (toolId: any) {
    console.log('ATBase: Received request for tool list validation.')

    if (!toolId || !toolId.data) {
        return Promise.reject(false)
    }

    return Promise.resolve(!!getToolById(toolId.data))
}
